// extracted by mini-css-extract-plugin
module.exports = {"inputs":"SavePattern_inputs__3PF26"};